import PropTypes from 'prop-types';
import React from 'react';
import {
  Player, BigPlayButton, LoadingSpinner,
} from 'video-react';
import './video-react.css'; // import css
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimesCircle,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import HLSSource from './HLSSource';
import './PlayerVideo.css';
import { customAuthUrl } from '../libs/authUrls';

const apiKey = get(window, 'Meteor.settings.public.apiKey', process.env.REACT_APP_API_KEY);
export default class PlayerVideo extends React.Component {
  static propTypes = {
    fluid: PropTypes.bool,
    height: PropTypes.number,
    poster: PropTypes.string,
    autoplay: PropTypes.bool,
    src: PropTypes.string,
    video: PropTypes.object,
    selectedId: PropTypes.string,
    onCloseOverlay: PropTypes.func,
    getCurrentTime: PropTypes.func,
    displayConnect: PropTypes.bool,
    displayShare: PropTypes.bool,
    isMobile: PropTypes.bool,
  }

  constructor(props) {
    super(props);
    this.state = { videoWidth: null };
  }

  componentDidMount() {
    // subscribe state change
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));
  }

  componentWillUnmount() {
    clearInterval(this.timerKey);
  }

  handleStateChange = (state) => {
    // copy player state to this component's state
    this.setState({
      player: state,
      currentTime: state.currentTime,
      video: state.video,
      isActive: state.isActive,
    });
    this.props.getCurrentTime(state.currentTime);
  }

  shouldComponentUpdate(prevProps) {
    const { src, video, displayConnect } = this.props;
    return src !== prevProps.src
      || (video && video._id) !== prevProps.video._id
      || displayConnect !== prevProps.displayConnect;
  }


  componentDidUpdate(prevProps) {
    if (this.props.src !== prevProps.src) {
      this.player.load();
    }
  }

  login = () => {
    window.location.href = customAuthUrl(null, [
      ['redirect_uri', window.location],
      ['disable_social_media', 'true'],
      ['apiKEY', apiKey],
    ]);
  }

  closeOverlay = () => {
    const { onCloseOverlay } = this.props;
    onCloseOverlay();
  }

  render() {
    const {
      fluid, height, src, displayConnect, poster, isMobile,
    } = this.props;

    if (displayConnect) {
      this.overlay.style.height = '0%';
      this.player.pause();
      //      this.player.seek(0);
      //    this.player.pause();
    }

    /* Check if the overlay is visible on the screen to toggle the scroll_lock class on the body */
    if (displayConnect) {
      if (!document.body.classList.contains('scroll_lock')) {
        document.body.classList.add('scroll_lock');
      }

      /* Adapt overlay size to the video in the background
       *  we must do it in javascript because of DOM hierarchy issue */
      const videoHeight = this.player.manager.rootElement.clientHeight;
      const overlayContent = this.overlay.querySelector('.overlay-content1');

      if (overlayContent) {
        overlayContent.style.minHeight = `${videoHeight}px`;
      }
    } else if (document.body.classList.contains('scroll_lock')) {
      document.body.classList.remove('scroll_lock');
    }

    return (
      <div>
        {isMobile
          ? <div ref={(node) => { this.overlay = node; }} style={{ height: displayConnect ? '100%' : '0%' }} className="overlay1">
            <div className="container">
              <div className="mx-auto card text-center text-light mb-3 w-100 overlay-contentMobile" style={{ borderRadius: '0px' }}>
                <img style={{ height }} src={poster} className="card-img-top" alt="..." />
                <div className="card-body ">
                  <h5 className="card-title">
                    <FormattedMessage id="player_subscribe_text1" />
                  </h5>
                  <p className="card-text">
                    <FormattedMessage id="player_subscribe_text2" />
                  </p>
                  <div className="row" >
                    <button onClick={this.closeOverlay} style={{ borderRadius: '0px' }} className="btn btn-primary crowdaa-close_btn col-12 mb-1">
                      <FontAwesomeIcon icon={faTimesCircle} />&nbsp;
                      <FormattedMessage id="player_close" />
                    </button >
                    <button onClick={this.login} style={{ borderRadius: '0px' }} className="btn active btn-success crowdaa-subscribe_btn col-12">
                      <FontAwesomeIcon icon={faCheckCircle} />&nbsp;
                      <FormattedMessage id="player_subscribe" />
                    </button >
                  </div>
                </div>
              </div>
            </div>
          </div>

          : <div ref={(node) => { this.overlay = node; }} style={{ height: displayConnect ? '100%' : '0%' }} className="overlay1">
            <div className="container py-1">
              <span className="closebtn" onClick={this.closeOverlay}>&times;</span>
              <div className="mx-auto card text-center text-light w-100 overlay-content1" style={{ borderRadius: '0px' }}>
                <img
                  style={{
                    height: 'auto',
                    margin: 'auto',
                    width: '500px',
                  }}
                  src={poster}
                  className="card-img-top rounded"
                  alt="..."
                />
                <div className="card-body ">
                  <h5 className="card-title">
                    <FormattedMessage id="player_subscribe_text1" />
                  </h5>
                  <p className="card-text">
                    <FormattedMessage id="player_subscribe_text2" />
                  </p>
                  <button onClick={this.closeOverlay} style={{ borderRadius: '0px' }} className="btn btn-primary crowdaa-close_btn btn-lg w-25 mr-1">
                    <FontAwesomeIcon icon={faTimesCircle} />&nbsp;
                    <FormattedMessage id="player_close" />
                  </button >
                  <button onClick={this.login} style={{ borderRadius: '0px' }} className="btn active btn-success crowdaa-subscribe_btn btn-lg w-25 ml-1">
                    <FontAwesomeIcon icon={faCheckCircle} />&nbsp;
                    <FormattedMessage id="player_subscribe" />
                  </button >
                </div>
                <img src="/img/Powered by Crowdaa.png" className="crowdaa_powered crowdaa_powered_overlay" alt="powered_by_crowdaa" />
              </div>
            </div>
          </div>
        }
        <Player ref={(node) => { this.player = node; }}
          aspectRatio="16:9"
          fluid={fluid}
          autoplay
          height={height}
          poster={poster}
          src={src}
        >
          <HLSSource isVideoChild src={src} type={'application/x-mpegURL'} />
          <BigPlayButton position="center" />
          <LoadingSpinner />
        </Player>
      </div>
    );
  }
}
